/*
 * サブシステム名：マスタ管理
 * 機能名：高速割引設定
 */
import DdFooterButton from '@/components/DdFooterButton'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'
import kessanKikan from '@/ddv2.library/apis/business/kessanKikan'
import message from '@/ddv2.library/messages'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdNumericBox = () => import('@/components/DdNumericBox')

export default {
  name: 'MstHiwayWaribiki',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      eigyoshoCd: '',
      tekiyoNendo: ''
    },
    rec: {
      januaryRate: '',
      februaryRate: '',
      marchRate: '',
      aprilRate: '',
      mayRate: '',
      juneRate: '',
      julyRate: '',
      augustRate: '',
      septemberRate: '',
      octoberRate: '',
      novemberRate: '',
      decemberRate: '',
      inpbox1: '',
      inpbox2: '',
      inpbox3: '',
      inpbox4: '',
      inpbox5: '',
      inpbox6: '',
      inpbox7: '',
      inpbox8: '',
      inpbox9: '',
      inpbox10: '',
      inpbox11: '',
      inpbox12: ''
    },
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    IsReadOnly: false,
    afterSearch: false,
    // 権限
    modeKengen: 0,
    modeOfEdit: 0,
    getNendo: '',
    getKessankikan: '',
    monthName: [],
    kisyuStart: 4
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdDefaultButton,
    DdFooterButton,
    DdCodeTextBox,
    DdNumericBox
  },
  watch: {
    'conditions.eigyoshoCd': function (n, o) {
      this.onChange()
    }
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      kihonJoho: 'DDMasters/mstKihonJoho'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisp () {
      return this.modeKengen !== 0
    },
    isDeleteButtonDisp () {
      return this.modeKengen !== 0 && this.modeKengen !== 1
    },
    isSaveButtonDisp () {
      return this.modeKengen !== 0
    },
    isDeleteButtonDisabled () {
      return this.rows.length === 0 || this.afterSearch === false
    },
    isSaveButtonDisabled () {
      return this.afterSearch === false
    },
    isEntryFieldDisabled () {
      return this.afterSearch === false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  // beforeRouteUpdate (to, from, next) {
  //   this.$refs.initialize()
  //   next()
  // },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText,
        afterSearch: this.afterSearch,
        rec: this.rec
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msyskubun', 'mstkihonjoho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise(resolve => {
            // const thisYString = `${new Date().getFullYear()}`
            kessanKikan.calcNendoByDate(filter.dateFormatter(new Date()), self.kihonJoho[0].kessanMonth, self.kihonJoho[0].jishaShimeDay, self.kihonJoho[0].togetsuKijunHandanKbn).then(data => {
              self.getNendo = data.payload
              console.log('●●(initialize)self.getNend:', self.getNendo)
              self.conditions.tekiyoNendo = self.getNendo
            }).then(e => {
              // kessanKikan.calculateNendoKikan(self.getNendo, self.kihonJoho[0].kessanMonth, self.kihonJoho[0].jishaShimeDay, self.kihonJoho[0].togetsuKijunHandanKbn).then(data => {
              //   self.getKessanKikan = data.payload
              //   console.log('●●月1', self.getKessanKikan)
              //   console.log('●●月2', self.getKessanKikan.item1)

              //   var tx = self.getKessanKikan.item1
              //   var sm = Number(tx.substr(5, 2))
              // 月の初めはcalclateNendokikanではなく基本情報のkessanMonthの次の月を使う
              const sm = Number(self.kihonJoho[0].kessanMonth) + 1

              self.kisyuSatrt = sm
              var i
              self.monthName = []
              for (i = 0; i < 12; i++) {
                var m = (sm + i) > 12 ? sm + i - 12 : sm + i
                self.monthName.push(m + '月')
              }
              // }).catch(e => {
              //   console.log('●●月error', self.getKessanKikan)
              // })
            })
            self.conditions = {
              eigyoshoCd: '',
              tekiyoNendo: self.getNendo
            }
            self.dataClear()
            self.cloneData = self.getCloneTargetMethod()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.conditions || {}
            self.search().then(() => {
              resolve()
            })
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstNenryoTankaEdit.settingButtonStatePromise', kengen)
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/MstHiwayWaribiki/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.dataClear()
          if (data.isExistsPayload) {
            self.rows = data.payload
          } else {
            self.rows = []
          }

          if (self.rows.length > 0) {
            var rec = self.rows[0]
            self.id = rec.id
            self.setRec(self, rec) // データ詰め替え
            console.log('★rec', self.rec)
          } else {
            modals.showAlert('COMI0101')
            self.rec = {
              id: 0,
              eigyoshoCd: self.conditions.eigyoshoCd,
              tekiyoNendo: self.conditions.tekiyoNendo,
              januaryRate: '',
              februaryRate: '',
              marchRate: '',
              aprilRate: '',
              mayRate: '',
              juneRate: '',
              julyRate: '',
              augustRate: '',
              septemberRate: '',
              octoberRate: '',
              novemberRate: '',
              decemberRate: '',
              inpbox1: '',
              inpbox2: '',
              inpbox3: '',
              inpbox4: '',
              inpbox5: '',
              inpbox6: '',
              inpbox7: '',
              inpbox8: '',
              inpbox9: '',
              inpbox10: '',
              inpbox11: '',
              inpbox12: ''
            }
            self.id = 0
          }
          self.afterSearch = true
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            kessanKikan.calcNendoByDate(filter.dateFormatter(new Date()), self.kihonJoho[0].kessanMonth, self.kihonJoho[0].jishaShimeDay, self.kihonJoho[0].togetsuKijunHandanKbn).then(data => {
              self.getNendo = data.payload
              console.log('●●(initialize)self.getNend:', self.getNendo)
              self.conditions.tekiyoNendo = self.getNendo
            })
            self.conditions = {
              eigyoshoCd: '',
              tekiyoNendo: self.getNendo
            }
            self.dataClear()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    /**
     * キャンセルボタンクリック
     * @param {*} e
     */
    onCancelButtonClick: function (e) {
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            // const thisYString = `${new Date().getFullYear()}`
            kessanKikan.calcNendoByDate(filter.dateFormatter(new Date()), self.kihonJoho[0].kessanMonth, self.kihonJoho[0].jishaShimeDay, self.kihonJoho[0].togetsuKijunHandanKbn).then(data => {
              self.getNendo = data.payload
              console.log('●●(initialize)self.getNend:', self.getNendo)
              self.conditions.tekiyoNendo = self.getNendo
            })
            self.conditions = {
              eigyoshoCd: '',
              tekiyoNendo: self.getNendo
            }
            self.dataClear()
            self.afterSearch = false
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    /**
     * 削除ボタンクリック
     * @param {*} e
     */
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          console.log(':::rec', self.rec)
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstHiwayWaribiki/Delete?id=${self.rec.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        // getTransitionBackParams: undefined
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            // param: { id: self.id }
            param: { }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        }
      }

      this.delete(opt).then((c) => {
        this.dataClear()
      })
    },
    /**
     * 保存ボタンクリック
     * @param {*} e
     */
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            this.onSearchButtonClick()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            // this.transition(0, { id: id }, this.initialize)
            // this.transition(0, { }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            // param: { id: self.id }
            param: { }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      var f
      this.restoreRec(this)
      if (this.id === 0) {
        f = this.HttpClient.post('/api/v1/MstHiwayWaribiki/CreateCustom', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/MstHiwayWaribiki/UpdateCustom?id=${this.id}`, this.rec)
      }
      return f
    },
    searchValidate: function () {
      if (Number(this.conditions.tekiyoNendo) >= 2000 && Number(this.conditions.tekiyoNendo) <= 2999) {
        return true
      }
      this.$refs.tekiyoNendo[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0120', ['適用年度', '2000', '2999']))
      return false
    },
    registerValidate: function () {
      return true
    },
    deleteValidate: function () {
      return true
    },
    dataClear: function () {
      this.afterSearch = false
      this.rec = {
        januaryRate: '',
        februaryRate: '',
        marchRate: '',
        aprilRate: '',
        mayRate: '',
        juneRate: '',
        julyRate: '',
        augustRate: '',
        septemberRate: '',
        octoberRate: '',
        novemberRate: '',
        decemberRate: '',
        inpbox1: '',
        inpbox2: '',
        inpbox3: '',
        inpbox4: '',
        inpbox5: '',
        inpbox6: '',
        inpbox7: '',
        inpbox8: '',
        inpbox9: '',
        inpbox10: '',
        inpbox11: '',
        inpbox12: ''
      }
    },
    onChange: function () {
      // 年度と営業所を変更したときは、検索しないと保存できない
      this.afterSearch = false
      console.log('aftersave be false -- have to serach')
    },
    setRec: function (self, rec) {
      var psArr = [
        rec.januaryRate ? (rec.januaryRate * 100).toFixed(2) : '',
        rec.februaryRate ? (rec.februaryRate * 100).toFixed(2) : '',
        rec.marchRate ? (rec.marchRate * 100).toFixed(2) : '',
        rec.aprilRate ? (rec.aprilRate * 100).toFixed(2) : '',
        rec.mayRate ? (rec.mayRate * 100).toFixed(2) : '',
        rec.juneRate ? (rec.juneRate * 100).toFixed(2) : '',
        rec.julyRate ? (rec.julyRate * 100).toFixed(2) : '',
        rec.augustRate ? (rec.augustRate * 100).toFixed(2) : '',
        rec.septemberRate ? (rec.septemberRate * 100).toFixed(2) : '',
        rec.octoberRate ? (rec.octoberRate * 100).toFixed(2) : '',
        rec.novemberRate ? (rec.novemberRate * 100).toFixed(2) : '',
        rec.decemberRate ? (rec.decemberRate * 100).toFixed(2) : ''
      ]
      self.rec = {
        ...rec,
        inpbox1: psArr[self.kisyuSatrt - 1],
        inpbox2: psArr[self.kisyuSatrt > 11 ? self.kisyuSatrt - 12 : self.kisyuSatrt],
        inpbox3: psArr[(self.kisyuSatrt + 1) > 11 ? self.kisyuSatrt + 1 - 12 : self.kisyuSatrt + 1],
        inpbox4: psArr[(self.kisyuSatrt + 2) > 11 ? self.kisyuSatrt + 2 - 12 : self.kisyuSatrt + 2],
        inpbox5: psArr[(self.kisyuSatrt + 3) > 11 ? self.kisyuSatrt + 3 - 12 : self.kisyuSatrt + 3],
        inpbox6: psArr[(self.kisyuSatrt + 4) > 11 ? self.kisyuSatrt + 4 - 12 : self.kisyuSatrt + 4],
        inpbox7: psArr[(self.kisyuSatrt + 5) > 11 ? self.kisyuSatrt + 5 - 12 : self.kisyuSatrt + 5],
        inpbox8: psArr[(self.kisyuSatrt + 6) > 11 ? self.kisyuSatrt + 6 - 12 : self.kisyuSatrt + 6],
        inpbox9: psArr[(self.kisyuSatrt + 7) > 11 ? self.kisyuSatrt + 7 - 12 : self.kisyuSatrt + 7],
        inpbox10: psArr[(self.kisyuSatrt + 8) > 11 ? self.kisyuSatrt + 8 - 12 : self.kisyuSatrt + 8],
        inpbox11: psArr[(self.kisyuSatrt + 9) > 11 ? self.kisyuSatrt + 9 - 12 : self.kisyuSatrt + 9],
        inpbox12: psArr[(self.kisyuSatrt + 10) > 11 ? self.kisyuSatrt + 10 - 12 : self.kisyuSatrt + 10]
      }
    },
    restoreRec: function (self) {
      const decimalRength = 4 // 本当は４ バグのため
      console.log('inpbox2', self.rec.inpbox2)
      console.log('inpbox2', self.rec.inpbox2 / 100)
      console.log('inpbox2', (self.rec.inpbox2 / 100).toFixed(3))
      var psArr = [
        self.rec.inpbox1 ? (self.rec.inpbox1 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox2 ? (self.rec.inpbox2 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox3 ? (self.rec.inpbox3 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox4 ? (self.rec.inpbox4 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox5 ? (self.rec.inpbox5 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox6 ? (self.rec.inpbox6 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox7 ? (self.rec.inpbox7 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox8 ? (self.rec.inpbox8 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox9 ? (self.rec.inpbox9 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox10 ? (self.rec.inpbox10 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox11 ? (self.rec.inpbox11 / 100).toFixed(decimalRength) : '',
        self.rec.inpbox12 ? (self.rec.inpbox12 / 100).toFixed(decimalRength) : ''
      ]
      console.log('psatr', psArr)
      self.rec.januaryRate = psArr[(1 - self.kisyuSatrt) < 0 ? (1 - self.kisyuSatrt + 12) : (1 - this.kisyuSatrt)]
      self.rec.februaryRate = psArr[(2 - self.kisyuSatrt) < 0 ? (2 - self.kisyuSatrt + 12) : (2 - this.kisyuSatrt)]
      self.rec.marchRate = psArr[(3 - self.kisyuSatrt) < 0 ? (3 - self.kisyuSatrt + 12) : (3 - this.kisyuSatrt)]
      self.rec.aprilRate = psArr[(4 - self.kisyuSatrt) < 0 ? (4 - self.kisyuSatrt + 12) : (4 - this.kisyuSatrt)]
      self.rec.mayRate = psArr[(5 - self.kisyuSatrt) < 0 ? (5 - self.kisyuSatrt + 12) : (5 - this.kisyuSatrt)]
      self.rec.juneRate = psArr[(6 - self.kisyuSatrt) < 0 ? (6 - self.kisyuSatrt + 12) : (6 - this.kisyuSatrt)]
      self.rec.julyRate = psArr[(7 - self.kisyuSatrt) < 0 ? (7 - self.kisyuSatrt + 12) : (7 - this.kisyuSatrt)]
      self.rec.augustRate = psArr[(8 - self.kisyuSatrt) < 0 ? (8 - self.kisyuSatrt + 12) : (8 - this.kisyuSatrt)]
      self.rec.septemberRate = psArr[(9 - self.kisyuSatrt) < 0 ? (9 - self.kisyuSatrt + 12) : (9 - this.kisyuSatrt)]
      self.rec.octoberRate = psArr[(10 - self.kisyuSatrt) < 0 ? (10 - self.kisyuSatrt + 12) : (10 - this.kisyuSatrt)]
      self.rec.novemberRate = psArr[(11 - self.kisyuSatrt) < 0 ? (11 - self.kisyuSatrt + 12) : (11 - this.kisyuSatrt)]
      self.rec.decemberRate = psArr[(12 - self.kisyuSatrt) < 0 ? (12 - self.kisyuSatrt + 12) : (12 - this.kisyuSatrt)]

      console.log('***save rec', self.rec)
    }
  }
}
